import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';

import { PortalSharedModule } from '../../_shared/shared.module';
import { TransferComponentsModule } from './transfer-components.module';
import { TransferRoutingModule } from './transfer-routing.module';
import { TransferComponent } from './transfer/transfer.component';

@NgModule({
  imports: [
    CommonModule,
    TransferRoutingModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    TransferComponentsModule,
  ],
  declarations: [TransferComponent],
})
export class TransferModule {}
